const SvgRadioButtonCheckedOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#349EB9"
      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8"
    />
    <path fill="#349EB9" d="M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10" />
  </svg>
);

export default SvgRadioButtonCheckedOutlined;
